import * as React from 'react';
import styles from './ObserverElement.css';
import { ORIENTATION } from 'constants/common';
const DEFAULT_THRESHOLD = 350;
export default class ObserverElement extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.stopObserving = () => {
            this.container && this.observer && this.observer.unobserve(this.container);
        };
        this.startObserving = () => {
            this.container && this.observer.observe(this.container);
        };
        this.checkPosition = (enteries) => {
            enteries.forEach(entry => {
                if (entry.isIntersecting && typeof this.props.onShow === 'function') {
                    this.props.onShow();
                    if (this.props.once) {
                        this.stopObserving();
                    }
                }
            });
        };
        this.containerRef = (c) => {
            this.container = c;
        };
    }
    componentDidMount() {
        let { threshold, orientation } = this.props;
        // If threshold is passed as 0 by parent components, we shouldn't
        // default to the default setting. Hence, we are checking for all falsy
        // values except zero for defaulting to the default threshold.
        if (!threshold && threshold !== 0) {
            threshold = DEFAULT_THRESHOLD;
        }
        let rootMargin = `0px 0px ${threshold}px 0px`;
        if (orientation === ORIENTATION.HORIZONTAL) {
            rootMargin = `0px 0px 0px ${threshold}px`;
        }
        let root;
        if (typeof this.props.setParentContainerRef === 'function') {
            root = this.props.setParentContainerRef();
        }
        this.observer = new IntersectionObserver(this.checkPosition, {
            root,
            rootMargin
        });
        this.startObserving();
    }
    componentWillUnmount() {
        this.stopObserving();
    }
    render() {
        return <div className={styles['waypoint']} ref={this.containerRef}/>;
    }
}
